<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <!-- 搜索区域 -->
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="10" :sm="12">
            <a-form-item :label="language['common.name']" style="margin-left:25px">
              <a-input :placeholder="language['common.pleaseInput']" v-model="queryParam.areaName"></a-input>
            </a-form-item>
          </a-col>
          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="6" :sm="24">
             <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 18px">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </a-col>
          </span>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator" :md="24" :sm="24" style="margin-top: -15px;margin-left: 25px">
      <a-button @click="handleAdd" type="primary" icon="plus" style="margin-top: 16px">{{language['button.add']}}</a-button>
      <a-button @click="batchDel" type="default">{{language['ipsys.common.batchDelete']}}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">



        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{language['common.edit']}}</a>
          <a-divider type="vertical"/>
          <a @click="handleDelete(record)">{{language['common.delete']}}</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <cst-bd-area-modal ref="areaModal" @ok="searchReset" ></cst-bd-area-modal>
  </a-card>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {getAction, postAction, deleteAction} from '@/api/manage'
  import CstBdAreaModal from './CstBdAreaModal'
  import {deleteByAreaId} from '@/api/api'
  export default {
    name: "AreaInfo",
    mixins: [JeecgListMixin],
    components: {
      CstBdAreaModal
    },
    data() {
      const { language } = this.$store.getters;
      return {
        description: '区域楼栋信息',
        currentAreaId: '',
        currentArea: {},
        // 表头
        columns: [{
            title: language['common.name'],
            align: "center",
            dataIndex: 'areaName'
          },
          {
            title: language['common.code'],
            align: "center",
            dataIndex: 'areaCode'
          },
          {
            title: language['basedata.remark'],
            align: "center",
            dataIndex: 'remark'
          },
          {
            title: language['common.createTime'],
            align: "center",
            dataIndex: 'createTime'
          },
          {
            title: language['common.creator'],
            align: "center",
            dataIndex: 'createBy'
          },

          {
            title: language['common.action'],
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 150
          }],
        url: {
          list: "/sys/area/childList",
          deleteBatch: '/sys/area/deleteBatch',
        }
      }
    },
    created() {
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      searchReset() {
        this.queryParam = {}
        this.loadData(1);
        this.$emit('loadTree');
      },
      loadData(arg) {
        if (!this.url.list) {
          this.$message.error("请设置url.list属性!")
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        let params = this.getQueryParams();//查询条件
        params.parentId = this.currentAreaId;
        getAction(this.url.list, params).then((res) => {
          if (res.success && res.result) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      handleAdd() {
        this.$refs.areaModal.add(this.currentArea)
        this.$refs.areaModal.title = this.language['common.insertButton']
      },
      handleEdit(record){
        this.$refs.areaModal.edit(record)
        this.$refs.areaModal.title = this.language['common.insertButton']
      },
      handleDelete(record) {
        var that = this
        this.$confirm({
          title: this.language['confirm.deletion'],
          content: this.language['sure.delete.selected'] + 1 +this.language['piece.data.node'],
          onOk: function () {
            deleteByAreaId({id: record.id}).then((resp) => {
              if (resp.success) {
                //删除成功后，去除已选中中的数据
                that.loadData(1);
                that.$emit('loadTree');
                that.onClearSelected()
                that.$message.success(that.language['common.deleteSuccess']+'!')

              } else {
                that.$message.warning(that.language['operationfailed']+'!')
              }
            })
          }
        })
      },
      batchDel: function () {
        console.log(this.selectedRowKeys)
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning(this.language['tip.messageSelectRecord'])
        } else {
          var ids = ''
          for (var a = 0; a < this.selectedRowKeys.length; a++) {
            ids += this.selectedRowKeys[a] + ','
          }
          var that = this
          this.$confirm({
            title: this.language['confirm.deletion'],
            content: this.language['sure.delete.selected'] +this.selectedRowKeys.length + this.language['piece.data.node'],
            onOk: function () {
              deleteAction(that.url.deleteBatch, {ids: ids}).then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.loadData(1);
                  that.$emit('loadTree');
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.message)
                }
              })
            }
          })
        }
      },
      open(record) {
        //console.log(record);
        this.currentAreaId = record.id;
        this.currentArea = record;
        this.loadData(1);
      },
      clearList() {
        this.currentAreaId = '';
        this.dataSource = [];
      },
    }
  }
</script>
<style scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .ant-card {
    margin-left: -30px;
    margin-right: -30px;
  }

  .table-page-search-wrapper {
    margin-top: -16px;
    margin-bottom: 16px;
  }
</style>